export const getTruncatedText = (text: string, length = 100): string => {
  if (!text) return '';

  if (text.length <= length) return text;

  const lastSpace = text.substring(0, length+1).lastIndexOf(' ');

  if (lastSpace === -1) return `${text.substring(0, length)}...`;

  return `${text.substring(0, lastSpace)}...`;
};

export const getAdminUrl = (): string => {
  const domain = window.location.hostname;

  if (domain.indexOf('urbansitter.com') > -1) {
      return 'https://admin.urbansitter.com';
  }

  return `https://admin-${domain}`;
};

// If assetUrl contains less than 4 slashes, it's just a base domain without any specific item path
export const isValidAssetUrl = (assetUrl?: string): boolean => !!assetUrl && /([^\/]*\/){4}/.test(assetUrl); // eslint-disable-line no-useless-escape

export const decodeHtmlText = (text: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

export const sentenceCase = (s?: string): string => {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

// Build a display name from a user-shaped object's firstName + lastName.
// Use this instead of accessing the legacy `name` field — the `firstName`
// + `lastName` pair is the canonical pattern across the codebase.
export const fullName = (
  user?: { firstName?: string | null; lastName?: string | null } | null,
): string => {
  if (!user) return '';
  return [user.firstName, user.lastName].filter(Boolean).join(' ');
};
